import thesisEarlier from './thesisEarlier'
import thesisSchoolExcellent from './thesisSchoolExcellent'
import courseScore from './courseScore'
import thesisProvinceExcellent from './thesisProvinceExcellent'
import examInspect from './examInspect'
import schoolSupervisor from './schoolSupervisor'
import provincialRandomInspection from './provincialRandomInspection'
import teacherWeightedScore from './teacherWeightedScore'
import teachingAccident from './teachingAccident'
import thesisComprehensive from './thesisComprehensive'
import thesisInspection from './thesisInspection'
import thesisReply from './thesisReply'
import thesisReplyEarlier from './thesisReplyEarlier'
import dataImport from './dataImport'
import collect from './collect'
import peerEval from './peerEval'
import base from './base';
import orgAuth from './orgAuth';
import orgAuthEmployee from './orgAuthEmployee';

export default {
    courseScore,
    thesisEarlier,
    thesisSchoolExcellent,
    thesisProvinceExcellent,
    examInspect,
    schoolSupervisor,
    provincialRandomInspection,
    teacherWeightedScore,
    teachingAccident,
    thesisComprehensive,
    thesisInspection,
    thesisReply,
    thesisReplyEarlier,
    dataImport,
    collect,
    peerEval,
    base,
    orgAuth,
    orgAuthEmployee
}